(function($){

  /**
   * initializeWineQuizBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */

   //Quiz programme
     /*
       Wine Types
         - Chardonnay = 1
         - Gold Rush Red = 2
         - Prospector's Proof Cabernet = 3
         - Zinfandel = 4
     */
   // QUESTIONS
   const questions = [
     {
       "question": "If you're not drinking wine, you would drink ____ like country star____?",
       "answer1": "Beer, Luke Bryan",
       "answer1Total": "2", //gold rush red
       "answer2": "Whiskey, Eric Church",
       "answer2Total": "4", //zinfandel
       "answer3": "Something sweet, Miranda Lambert",
       "answer3Total": "1", //chardonnay
       "answer4": "Wine (always)! Carly Pearce",
       "answer4Total": "3" //prospectors cabernet
     },
     {
       "question": "What is your favorite country music wine song?",
       "answer1": "Hole in the Bottle by Kelsea Ballerini",
       "answer1Total": "4", //zinfandel
       "answer2": "Sangria by Blake Shelton",
       "answer2Total": "2", //gold rush red
       "answer3": "Champagne Night by Lady A",
       "answer3Total": "1", //chardonnay
       "answer4": "Hide the Wine Add by Carly Pearce",
       "answer4Total": "3" //prospectors cabernet
     },
     {
       "question": "When I hear 'Wine,  Beer, Whiskey' by Little Big Town, I ____.",
       "answer1": "Belt it loud for everyone to hear.",
       "answer1Total": "3", //prospectors cabernet
       "answer2": "Sing it softly",
       "answer2Total": "2", //gold rush red
       "answer3": "Sing it in my head, not aloud",
       "answer3Total": "1", //chardonnay
       "answer4": "I don&#39;t know the lyrics to this song.",
       "answer4Total": "4" //
     },
     {
       "question": "I have been to ____ country music concerts.",
       "answer1": "0",
       "answer1Total": "1", //chardonnay
       "answer2": "1-5",
       "answer2Total": "4", //zinfandel
       "answer3": "6-10",
       "answer3Total": "2", //gold rush red
       "answer4": "11+",
       "answer4Total": "3" //prospectors cabernet
     },
     {
       "question": "My favorite time to listen to country music is _____.",
       "answer1": "Summer BBQ",
       "answer1Total": "2", //gold rush red
       "answer2": "Wine nights in with friends",
       "answer2Total": "1", //chardonnay
       "answer3": "Out at a restaurant/bar",
       "answer3Total": "3", //prospectors cabernet
       "answer4": "On a road trip",
       "answer4Total": "4" //zinfandel
     },
     {
       "question": "My favorite barbecue food to pair with wine is ____.",
       "answer1": "Grilled Halibut",
       "answer1Total": "1", //chardonnay
       "answer2": "Steak or burgers",
       "answer2Total": "3", //prospectors cabernet
       "answer3": "Brisket or BBQ Pork Ribs",
       "answer3Total": "4", //zinfandel
       "answer4": "Grilled Salmon",
       "answer4Total": "2" //gold rush red
     },
     {
       "question": "When it's my turn to DJ/on aux, my go to artist to play is ____.",
       "answer1": "Chris Stapleton",
       "answer1Total": "2", //gold rush red
       "answer2": "Lee Brice",
       "answer2Total": "4", //zinfandel
       "answer3": "Luke Combs",
       "answer3Total": "3", //prospectors cabernet
       "answer4": "Blake Shelton",
       "answer4Total": "1" //chardonnay
     },
     {
       "question": "Pick a country music star that you would want to share a glass of wine with:",
       "answer1": "Carrie Underwood",
       "answer1Total": "2", //gold rush red
       "answer2": "Zac Brown",
       "answer2Total": "1", //chardonnay
       "answer3": "Darius Rucker",
       "answer3Total": "4", //zinfandel
       "answer4": "Brandi Carlile",
       "answer4Total": "3" //prospectors cabernet
     },
     {
       "question": "My favorite country outfit item is ____.",
       "answer1": "Cowboy hat",
       "answer1Total": "3", //prospectors cabernet
       "answer2": "Boots",
       "answer2Total": "1", //chardonnay
       "answer3": "Plaid flannel shirt",
       "answer3Total": "4", //zinfandel
       "answer4": "Denim",
       "answer4Total": "2" //gold rush red
     },
     {
       "question": "My favorite activity to do out in the country is ____.",
       "answer1": "Hunt",
       "answer1Total": "3", //prospectors cabernet
       "answer2": "Fish",
       "answer2Total": "1", //chardonnay
       "answer3": "Barbecue",
       "answer3Total": "4", //zinfandel
       "answer4": "Ride horses",
       "answer4Total": "2" //gold rush red
     }
   ]

  var initializeWineQuizBlock = function( $block ) {
    var id = '#'+$block[0].id
    if(id !== '#'){
      acm_quiz(questions);
    }
  }

  // Initialize each block on page load (front end).
  $(document).ready(function(){
      $('.acm-quiz').each(function(){
        initializeWineQuizBlock( $(this) );
      });
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
      window.acf.addAction( 'render_block_preview/type=acm_quiz', initializeWineQuizBlock );
  }

})(jQuery);
